<template>
  <div class="panel-body">
    <form v-on:submit="save" action="#" method="post" id="company_info_form" >
      <div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 m-b" v-if="disable && !$auth.check('super_admin')">
            <div  class="alert-info p-xs">
              <div class="text-primary"><i class="fa fa-exclamation-triangle fa-1x text-warning"></i> The content has been validated and can no longer be modified by the user. <a class="text-warning" @click="openSupport()">Contact our support</a> if needed.
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <label class="col-sm-3 control-label text-left m-t">Preference</label>
              <div class="col-sm-9">
                <div class="checkbox checkbox-info" id="sme">
                  <input type="checkbox" style="position: absolute; opacity: 0;" name="isOpenForCollaboration" :disabled="disable" v-model="localCompany.is_open_for_collaboration">
                  <label class=""> My company is interested to be contacted for a collaboration
                    <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'Checking this box allows company to be more visible in the results of queries made with our search engine.'"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 15px">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label for="cp_name" class="col-sm-3 control-label required text-left">Organisation Name</label>
              <div class="col-sm-9">
                <input id="cp_name" v-model="localCompany.name" class="form-control" required
                       :class="{'has-error' : errorName, 'has-success' : errorName === false}">
                <typeahead v-model="queryWiki" target="#cp_name" class="inputSearchCompanyTypeahead" :async-function="getCompanyByName" ></typeahead>
                <label v-if="errorName" class="error">{{ errorName }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label for="category" class="col-sm-3 control-label text-left">Category</label>
              <div class="col-sm-9">
                <v-select id="category" :options="businessCategories" label="name" v-model="localCompany.category" :searchable="true"
                          :class="{'has-error' : errorCategory, 'has-success' : errorCategory === false}" :disabled="disable"></v-select>

                <label v-if="errorCategory" class="error">{{ errorCategory }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label for="website" class="col-sm-3 control-label required text-left">Website</label>
              <div class="col-sm-9">
                <input id="website" v-model="localCompany.website" class="form-control" required placeholder="www."
                       :class="{'has-error' : errorWebsite, 'has-success' : errorWebsite === false}" :disabled="disable">
                <label v-if="errorWebsite" class="error">{{ errorWebsite }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label for="city" class="col-sm-3 control-label required text-left">City</label>
              <div class="col-sm-9">
                <input id="city" v-model="localCompany.city" class="form-control" required placeholder="City"
                       :class="{'has-error' : errorCity, 'has-success' : errorCity === false}" :disabled="disable">
                <label v-if="errorCity" class="error">{{ errorCity }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label class="col-sm-3 control-label required text-left">Country
                <span v-if="errorCountry" class="error">{{ errorCountry }}</span>
              </label>
              <div class="col-sm-9">
              <v-select id="cp_country" :options="countries" label="name" v-model="localCompany.country"
                        :searchable="true" :dropdownParent="'company_info_form'"
                        :class="{'has-error' : errorCountry, 'has-success' : errorCountry === false}" :disabled="disable"></v-select>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label  class="col-sm-3 control-label text-left">Contact Person
                <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'Contact Person for Business development'" style="cursor: pointer;"></i>
              </label>
              <div class="col-sm-9">
                <div class="row">
                  <div class="col-xs-6">
                    <div class="form-group ">
                      <label for="contact_name">Name
                        <span v-if="errorContactName" class="error">{{ errorContactName }}</span>
                      </label>
                      <input v-model="localCompany.contact_name" id="contact_name" class="form-control" :class="{'has-error'
          : errorContactName, 'has-success' : errorContactName === false}" :disabled="disable">
                    </div>
                  </div>

                  <div class="col-xs-6">
                    <div class="form-group">
                      <label for="contact_position">Position
                        <span v-if="errorContactPosition" class="error">{{ errorContactPosition }}</span>
                      </label>
                      <input v-model="localCompany.contact_position" id="contact_position" class="form-control"  :class="{'has-error'
          : errorContactPosition, 'has-success' : errorContactPosition === false}" :disabled="disable">
                    </div>
                  </div>

                  <div class="col-xs-6">
                    <div class="form-group">
                      <label for="contact_email">Email
                        <span v-if="errorContactEmail" class="error">{{ errorContactEmail }}</span>
                      </label>
                      <input v-model="localCompany.contact_email" id="contact_email" class="form-control"  :class="{'has-error'
          : errorContactEmail, 'has-success' : errorContactEmail === false}" :disabled="disable">
                    </div>
                  </div>

                  <div class="col-xs-6">
                    <div class="form-group">
                      <label for="contact_phone">Phone
                        <span v-if="errorContactPhone" class="error">{{ errorContactPhone }}</span>
                      </label>
                      <input v-model="localCompany.contact_phone" id="contact_phone" class="form-control"  :class="{'has-error'
          : errorContactPhone, 'has-success' : errorContactPhone === false}" :disabled="disable">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group ">
              <label for="activity_overview" class="col-sm-3 control-label required text-left">Organisation description
                <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'The additional information allows our ranking algorithms to better target your company'" style="cursor: pointer;"></i>
              </label>
              <div class="col-sm-9">
        <textarea v-model="localCompany.activity_overview" id="activity_overview" class="form-control" :disabled="disable" minlength="300"  maxlength="3000" placeholder="300 (min) - 3000 (max) characters with specific activities and products"
                  rows="3" cols="3" :class="{'has-error' : errorActivityOverview, 'has-success' : errorActivityOverview === false}" required></textarea>
                <span class="help-block m-b-none text-right" v-if="localCompany.activity_overview">{{localCompany.activity_overview.length}} Characters</span>
                <label v-if="errorActivityOverview" class="error">{{ errorActivityOverview }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label class="col-sm-3 control-label text-left required">Keywords
                <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'Enter specialities and product categories. Each tag no longer than 35 characters.'" style="cursor: pointer;"></i>
              </label>
              <div class="col-sm-9">
                <keywords ref="skills" v-model="skills"
                          :placeholder="'Enter specialities and product categories'" :itemClassName="'companySkills'" :disabled="disable"></keywords>
                <label v-if="errorSkills" class="error">{{ errorSkills }}</label>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label for="incorporation_date" class="col-sm-3 control-label text-left">Incorp. date</label>
              <div class="col-sm-9">
                <date-picker id="incorporation_date" v-model="localCompany.incorporation_date" :config="configDate"  placeholder="Select Incorporation Year"
                             class="form-control" :disabled="disable"/>
                <label v-if="errorIncorporationDate" class="error">{{ errorIncorporationDate }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label for="cp_industrial_classification" class="col-sm-3 control-label text-left">Industrial Classification</label>
              <div class="col-sm-9">
                <v-select id="cp_industrial_classification" :options="industrialClassification" label="industry" v-model="localCompany.industrial_classification" :searchable="true"
                          :disabled="disable" :class="{'has-error' : errorIndustrialClassification, 'has-success' : errorIndustrialClassification === false}"></v-select>
                <label v-if="errorIndustrialClassification" class="error">{{ errorIndustrialClassification }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label for="cp_nb_employees" class="col-sm-3 control-label text-left">Number of Employees</label>
              <div class="col-sm-9">
                <v-select id="cp_nb_employees" :options="nbEmployees" label="name" v-model="localCompany.nb_employees" :searchable="true"
                          :class="{'has-error' : errorNbEmployees, 'has-success' : errorNbEmployees === false}" :disabled="disable"></v-select>
                <label v-if="errorNbEmployees" class="error">{{ errorNbEmployees }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
            <div class="form-group">
              <label for="nb_patents" class="col-sm-3 control-label text-left">Number of Patents</label>
              <div class="col-sm-9">
                <input id="nb_patents" type="number" min="0" v-model="localCompany.nb_patents" class="form-control"
                       :class="{'has-error' : errorNbPatents, 'has-success' : errorNbPatents === false}" :disabled="disable">
                <label v-if="errorNbPatents" class="error">{{ errorNbPatents }}</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 25px">
            <div class="form-group"  v-bind:class="{'has-error' : errorFiles, 'has-info' : errorFiles === false}">
              <label for="files" class="col-sm-3 control-label text-left">Add files
                <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'Company description /Product info /Patent /Other'" style="cursor: pointer;"></i>
              </label>
              <div class="col-sm-9">
                <div class="row text-center">
                <upload-file id="files" :files="localCompany.files" :type="'company_doc'" :uploadFiles="uploadFiles" :removeFile="removeFile" />
                <span v-if="errorFiles" class="help-block text-danger">{{ errorFiles }}</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="text-right m-t-xs">
          <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">
            <template v-if=" $auth.check('super_admin')">Save & validate</template>
            <template v-else>Save changes</template>
          </vue-ladda>
        </div>
      </div>
    </form>
    <div class="modal fade hmodal-info" ref="updateCompanyNotificationModal" tabindex="-1" role="dialog"  aria-hidden="true" v-if="!disable">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
          </div>
          <div class="modal-body text-center text-info">
            <div>
              <h4>Thank you for your contribution!</h4>
               It will be put online as soon as an administrator has validated it.<br>This usually takes 24 hours.
            </div>
          </div>
          <div class="modal-footer">
            <router-link :to="$user.isBasic()?{name: 'Start'}:{name: 'Dashboard'}" class="btn btn-default" data-dismiss="modal">Close</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style >
  #company_info_form .v-select input[type=search], #company_info_form .v-select input[type=search]:focus {
    border: none;
  }
</style>
<script>
import vSelect from 'vue-select'
import VueLadda from 'vue-ladda'
import Keywords from './KeywordBox'
import UploadFile from '../../components/question/UploadFile'
import DatePicker from 'vue-bootstrap-datetimepicker'

export default {
  components: {
    VueLadda,
    vSelect,
    Keywords,
    UploadFile,
    DatePicker
  },
  name: 'CompanyInformationV2',
  props: ['company', 'userId'],
  watch: {
    company: function (company) {
      this.initCompany()
    },
    localCompany: function (company) {
      if (company.is_validated && !this.$auth.check('super_admin')) {
        this.disable = true
      } else {
        this.disable = false
      }
    }
  },
  data () {
    return {
      localCompany: {
        id: null,
        name: null,
        address1: null,
        city: null,
        zip_code: null,
        website: null,
        main_activity: null,
        activity_overview: null,
        is_open_for_collaboration: true,
        category: null,
        keywords: null,
        incorporation_date: null,
        nb_employees: null,
        nb_patents: null,
        country: null,
        industrial_classification: null,
        files: [],
        contact_name: null,
        contact_phone: null,
        contact_email: null,
        contact_position: null
      },
      uploadFiles: [],
      skills: null,
      files: null,
      errorName: null,
      errorCity: null,
      errorCountry: null,
      errorWebsite: null,
      errorMainActivity: null,
      errorActivityOverview: null,
      errorCategory: null,
      errorIncorporationDate: null,
      errorIndustrialClassification: null,
      errorNbEmployees: null,
      errorNbPatents: null,
      errorContactName: null,
      errorContactEmail: null,
      errorContactPhone: null,
      errorContactPosition: null,
      errorFiles: null,
      errorSkills: null,
      queryWiki: '',
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      countries: [],
      nbEmployees: [],
      industrialClassification: [],
      businessCategories: [],
      configDate: {
        format: 'YYYY',
        useCurrent: false
      },
      disable: false

    }
  },
  methods: {
    save: async function (event) {
      event.preventDefault()
      this.submit.loading = true

      this.errorName = null
      this.errorCity = null
      this.errorCountry = null
      this.errorWebsite = null
      this.errorActivityOverview = null
      if (this.skills) {
        this.axios.patch('user/' + this.userId + '/companyInformation', {
          id: this.localCompany.id,
          name: this.localCompany.name,
          city: this.localCompany.city,
          website: this.localCompany.website,
          main_activity: this.localCompany.main_activity,
          activity_overview: this.localCompany.activity_overview,
          country_id: this.localCompany.country === undefined ? null : this.localCompany.country.id,

          is_open_for_collaboration: this.localCompany.is_open_for_collaboration,
          nb_patents: this.localCompany.nb_patents,
          incorporation_date: this.localCompany.incorporation_date ? this.localCompany.incorporation_date : null,
          category_id: this.localCompany.category ? this.localCompany.category.id : null,
          nb_employees_id: this.localCompany.nb_employees ? this.localCompany.nb_employees.id : null,
          industrial_classification_id: this.localCompany.industrial_classification ? this.localCompany.industrial_classification.id : null,
          contact_name: this.localCompany.contact_name,
          contact_phone: this.localCompany.contact_phone,
          contact_email: this.localCompany.contact_email,
          contact_position: this.localCompany.contact_position

        }).then((response) => {
          this.localCompany.id = (response.data.company_id) ? response.data.company_id : response.data.id
          this.upload().then((response) => {
            this.saveKeywords().then((response) => {
              this.getResources()
              this.$notify({
                type: 'success',
                title: 'Company Information is saved',
                placement: 'bottom-right'
              })
              if (!this.$auth.check('super_admin')) {
                $(this.$refs.updateCompanyNotificationModal).modal('toggle')
              }
              this.$eventHub.$emit('refreshProfile', 'editCompany')
            })
          })
        }).catch((error) => {
          let errors = error.response.data.errors

          if (typeof errors['name'] !== 'undefined') {
            this.errorName = errors['name'][0]
          } if (typeof errors['city'] !== 'undefined') {
            this.errorCity = errors['city'][0]
          } if (typeof errors['country_id'] !== 'undefined') {
            this.errorCountry = errors['country_id'][0]
          } if (typeof errors['website'] !== 'undefined') {
            this.errorWebsite = errors['website'][0]
          } if (typeof errors['activity_overview'] !== 'undefined') {
            this.errorActivityOverview = errors['activity_overview'][0]
          }
        }).finally(() => {
          this.submit.loading = false
        })
      } else {
        this.submit.loading = false
        this.errorSkills = 'Field required! Please enter specialities and product categories. Each tag no longer than 35 characters.'
      }
    },
    getResources: function () {
      this.getCountries()
      this.getCategories()
      this.getNbEmployees()
      this.getIndustrialClassification()
    },
    initCompany: function () {
      if (this.company !== null) {
        this.getCompany(this.company.id)
      }
    },
    getCompany: function (companyId) {
      this.axios.get('/company/' + companyId + '?relations={keywords.keyword,files,country,industrialClassification,nbEmployees,category,contactFunction}')
        .then((response) => {
          this.localCompany = response.data
          if (this.localCompany.keywords) {
            let keywords = []
            this.localCompany.keywords.forEach((kyw) => {
              if (typeof kyw.keyword.keyword !== 'undefined') keywords.push(kyw.keyword.keyword)
            })
            this.skills = keywords.join(',')
          }
        })
        .catch((error) => {
        })
    },
    getCountries: function () {
      this.axios.get('/countries')
        .then((response) => {
          this.countries = response.data
        })
        .catch((error) => {
        })
    },
    getCategories: function () {
      this.axios.get('/businessCategories')
        .then((response) => {
          this.businessCategories = response.data
        })
        .catch((error) => {
        })
    },
    getNbEmployees: function () {
      this.axios.get('/nbEmployees')
        .then((response) => {
          this.nbEmployees = response.data
        })
        .catch((error) => {
        })
    },
    getIndustrialClassification: function () {
      this.axios.get('/industrialClassification')
        .then((response) => {
          this.industrialClassification = response.data
        })
        .catch((error) => {
        })
    },
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.uploadFiles.length !== 0) {
          let data = new FormData()

          this.uploadFiles.forEach((file) => {
            data.append('files[]', file)
          })
          data.append('target', 'company_file')
          data.append('additional_path', this.userId)

          this.axios.post('/files/', data).then((response) => {
            this.uploadFiles.forEach((file) => {
              if (typeof response.data.files[file.name] !== 'undefined') {
                this.localCompany.files.push({filename: response.data.path + response.data.files[file.name]})
                this.axios.post('company/' + this.localCompany.id + '/file', {
                  filename: response.data.path + response.data.files[file.name],
                  type: file.content_type ? file.content_type.name : 'Other'
                }).then((response) => {
                })
              }
            })
            this.uploadFiles = []
            resolve(response)
          }).catch((error) => {
            if (typeof error.response !== 'undefined') {
              if (error.response.status === 413) {
                this.$notify({
                  type: 'danger',
                  title: 'An error has occurred, max upload size is 10 Mo',
                  placement: 'bottom-right'
                })
              } else {
                let errors = error.response.data.errors
                switch (error.response.data.code) {
                  case 1:
                    this.errorFiles = errors['files'][0]
                    break
                }
              }
            }
            reject(error)
          })
        } else {
          resolve(null)
        }
      })
    },
    saveKeywords: function () {
      return new Promise((resolve, reject) => {
        let keywords = this.skills.split(',')
        if (keywords.length !== 0) {
          this.axios.post('company/' + this.localCompany.id + '/keywords', {
            keywords: keywords
          }).then((response) => {
            resolve(response)
          }).catch((error) => {
            if (typeof error.response !== 'undefined') {
              if (error.response.status === 413) {
                this.$notify({
                  type: 'danger',
                  title: 'An error has occurred, when add keyword skills',
                  placement: 'bottom-right'
                })
              } else {
                let errors = error.response.data.errors
                switch (error.response.data.code) {
                  case 1:
                    this.errorKeywords = errors['keywords'][0]
                    break
                }
              }
            }
            reject(error)
          })
        }
      })
    },
    getCompanyByName: function (query, done) {
      if (query.length > 5) {
        this.axios.get('/companies/' + query + '?relations={country}')
          .then((response) => {
            let Items = []
            if (response.data) {
              response.data.forEach((company) => {
                let cleanName = company.name.replace(/<[^>]*>?/gm, '')
                let str = '<span id="item-' + company.id + '" data-id="' + company.id + '" data-name="' + cleanName + '" class="typeahead-company-item">'
                str += '<strong>' + company.name + '</strong><br><i>'
                str += (company.address ? company.address + '<br> ' : '') + (company.city ? company.city + ' ' : '') + (company.zip_code ? company.zip_code + ' ' : '')
                if (company.country && typeof company.country.name !== 'undefined' && company.country.name !== 'undefined' && company.country.name !== 'Incomplete') str += '<br>' + company.country.name
                str += '</i></span'
                Items.push(str)
              })
            }
            done(Items)
          })
          .catch((error) => {
          })
      }
    },
    removeFile: function (file) {
      if (typeof file.id !== 'undefined') {
        this.axios.delete('file/company_file/' + file.id).then((response) => {
          this.getCompany(this.company.id)
        }).catch((error) => {

        })
      }
    },
    openSupport: function () {
      let iframe = document.getElementById('launcher')
      let supportButton = iframe.contentWindow.document.querySelector('#Embed button')

      if (typeof supportButton !== 'undefined') {
        supportButton.click()
      }
    }
  },
  mounted () {
    $('.inputSearchCompanyTypeahead').on('click', (e, datum) => {
      e.preventDefault()
      let elm = $(e.target).find('.typeahead-company-item')
      if (elm.length === 0) {
        elm = $(e.target).parents('.typeahead-company-item')
      }
      if (elm.length === 1) {
        this.queryWiki = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
        this.localCompany.name = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
        this.getCompany(elm.attr('data-id'))
      }
    })
    $('#cp_name').on('keypress', (e) => {
      if (event.keyCode === 13) {
        e.preventDefault()
        let elm = $('.inputSearchCompanyTypeahead').find('li.active .typeahead-company-item')
        if (elm) {
          this.queryWiki = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
          this.localCompany.name = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
          this.getCompany(elm.attr('data-id'))
        }
      }
    })
    $('[data-toggle="popover"]').popover({
      trigger: 'click hover',
      placement: 'top',
      container: 'body',
      html: true
    })
    $('[data-toggle="popover"][data-timeout]').on('shown.bs.popover', function () {
      let _popover = $(this)
      let _time = $(this).data('timeout') ? $(this).data('timeout') : 3000
      setTimeout(function () {
        _popover.popover('hide')
      }, _time)
    })
  },
  beforeMount () {
    this.getResources()
    this.initCompany()
    this.$eventHub.$on('isComanyOpenForCollaboration', (value) => {
      this.localCompany.is_open_for_collaboration = value
    })
  },
  beforeDestroy () {
    this.$eventHub.$off('isComanyOpenForCollaboration')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/CompanyInformationV2.vue